// UI strings added with the 2026 redesign. Merged into ./translations.js.
// Armenian and Russian copy is a draft: have a native speaker proofread before release.

const cpr = {
    am: {
        price_on_request: 'Գինը՝ ըստ հարցման',
        parking_title: 'Ավտոկայանատեղի',
        hero_title: 'Քո նոր բնակարանը Երևանում',
        hero_text: 'Երևանի ամենաորակյալ բնակարանների բացառիկ վաճառք՝ առանց միջնորդավճարի։',
        no_commission_title: 'Առանց միջնորդավճարի',
        projects_title: 'Մեր նախագծերը',
        building_details: 'Շենքի մանրամասներ',
        view_photo: 'Դիտել լուսանկարը',
        skip_to_content: 'Անցնել բովանդակությանը',
        field_required: 'Պարտադիր դաշտ',
        invalid_email: 'Էլ. փոստի ձևաչափը սխալ է',
        invalid_phone: 'Հեռախոսահամարի ձևաչափը սխալ է',
        your_name_label: 'Անուն',
        phone_label: 'Հեռախոս',
        email_label: 'Էլ. փոստ',
        message_label: 'Հաղորդագրություն',
        sending: 'Ուղարկվում է…',
        send_failed: 'Չհաջողվեց ուղարկել։ Խնդրում ենք զանգահարել մեզ կամ փորձել կրկին։',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        menu: 'Մենյու',
        close: 'Փակել',
        language: 'Լեզու',
    },
    en: {
        price_on_request: 'Price on request',
        parking_title: 'Parking',
        hero_title: 'Your new home in Yerevan',
        hero_text: 'Exclusive sales of premium new-build apartments in Yerevan, with no commission.',
        no_commission_title: 'No commission',
        projects_title: 'Our projects',
        building_details: 'Building details',
        view_photo: 'View photo',
        skip_to_content: 'Skip to content',
        field_required: 'This field is required',
        invalid_email: 'Enter a valid email address',
        invalid_phone: 'Enter a valid phone number',
        your_name_label: 'Name',
        phone_label: 'Phone',
        email_label: 'Email',
        message_label: 'Message',
        sending: 'Sending…',
        send_failed: 'We could not send your message. Please call us or try again.',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        menu: 'Menu',
        close: 'Close',
        language: 'Language',
    },
    ru: {
        price_on_request: 'Цена по запросу',
        parking_title: 'Паркинг',
        hero_title: 'Ваша новая квартира в Ереване',
        hero_text: 'Эксклюзивная продажа премиальных квартир в новостройках Еревана без комиссии.',
        no_commission_title: 'Без комиссии',
        projects_title: 'Наши проекты',
        building_details: 'Подробнее о здании',
        view_photo: 'Открыть фото',
        skip_to_content: 'Перейти к содержанию',
        field_required: 'Обязательное поле',
        invalid_email: 'Неверный формат email',
        invalid_phone: 'Неверный формат телефона',
        your_name_label: 'Имя',
        phone_label: 'Телефон',
        email_label: 'Email',
        message_label: 'Сообщение',
        sending: 'Отправка…',
        send_failed: 'Не удалось отправить сообщение. Позвоните нам или попробуйте ещё раз.',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        menu: 'Меню',
        close: 'Закрыть',
        language: 'Язык',
    },
};

export default cpr;
